import React, { useEffect, useState } from "react";

import { Modal } from "src/components/Modal/Modal";
import Input from "src/components/Input/Input";
import Button from "src/components/Button/Button";
import Checkbox from "src/components/Checkbox/Checkbox";

import { dollarsLabel, dollarsToPoints, maxDollarInput, pointsToDollars } from "./pointsReminder";

import "./PointsReminder.scss";

interface IProps {
  isShown: boolean;
  busy: boolean;
  availablePoints: number;
  maxPoints: number;
  onRedeem: (points: number, dontRemind: boolean) => void;
  onContinue: (dontRemind: boolean) => void;
  onDismiss: () => void;
}

const PointsReminderModal: React.FC<IProps> = (props) => {
  const [amount, setAmount] = useState("");
  const [dontRemind, setDontRemind] = useState(false);
  const maxDollars = pointsToDollars(props.maxPoints);

  useEffect(() => {
    if (props.isShown) {
      const dollars = maxDollarInput(props.maxPoints);
      setAmount(props.maxPoints > 0 ? dollars : "");
      setDontRemind(false);
    }
  }, [props.isShown, props.maxPoints]);

  const points = dollarsToPoints(amount);
  const redeemDisabled = props.busy || points <= 0 || points > props.maxPoints;
  const buttonLabel = amount && amount !== "." ? `Redeem $${amount.replace(/\.$/, "")}` : "Redeem";

  return (
    <Modal
      className="pointsReminder"
      isShown={props.isShown}
      hide={props.onDismiss}
      modalContent={
        <div className="pointsReminderBody">
          <h2>You have club points</h2>
          <p className="available">You have {dollarsLabel(pointsToDollars(props.availablePoints))} available with this club.</p>
          <p className="note">1,000 points = $1.00</p>
          <p className="note">Points reduce the club's portion only</p>
          <Input
            label="Amount to Redeem"
            id="pointsReminderAmount"
            type="text"
            inputMode="decimal"
            value={amount}
            onChange={(e) => {
              const raw = e.target.value;
              if (raw === "" || /^\d*\.?\d{0,2}$/.test(raw)) {
                setAmount(raw);
              }
            }}
            placeholder={`Max: ${dollarsLabel(maxDollars)}`}
          />
          <Checkbox
            id="dontRemindPoints"
            value={dontRemind}
            onChange={(e) => setDontRemind(e.target.checked)}
            label="Don't remind me that I have points"
          />
          <div className="actions">
            <Button type="button" variant="secondary" disabled={props.busy} onClick={() => props.onContinue(dontRemind)}>
              Continue without points
            </Button>
            <Button type="button" disabled={redeemDisabled} isLoading={props.busy} onClick={() => props.onRedeem(points, dontRemind)}>
              {buttonLabel}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default PointsReminderModal;
